import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import Guide from '@/components/Guide/index.vue' //引导页

import Home from '../components/HomePage.vue'
import Wyxf from '../components/Wyxf/index.vue' //发票管理
import Fpgl from '../components/Fpgl/index.vue' //发票管理
import Free from '../components/Free/index.vue' //非审核-免费会议

import ChargePay from '../components/Charge/pay.vue' //非审核收费会议-支付
import ChargePayIndex from '../components/Charge/index.vue' //非审核收费会议
import ChargeRemittance from '../components/Charge/remittance.vue' //非审核收费会议-转账汇款
import RemittanceIndex from '../components/Charge/voucherIndex.vue' //非审核收费会议-转账汇款 跳转页面
import Examine from '../components/Examine/index.vue' //审核会议
import NotFoundComponent from '@/components/404/NotFoundComponent' // 404
import getWxOpenId from '@/components/getWxOpenId/index.vue'
import getWxOpenIdGrzx from '@/components/getWxOpenId/grzxIndex.vue'

import Personal from '@/components/Personal/index.vue' //个人中心
import testindex from '@/components/Personal/testindex.vue' //个人中心测试
import PersonalLogin from '@/components/Personal/login.vue' //登录
import testlogin from '@/components/Personal/testlogin.vue' //登录测试
import PersonalTeamreg from '@/components/Personal/teamreg.vue' //经办人注册
import PersonalTeammember from '@/components/Personal/teammember.vue' //团队成员管理
import PersonalTeammemberFp from '@/components/Personal/teammember/fp.vue' //团队成员管理 发票管理跳转
import PersonalTeammemberView from '@/components/Personal/teammember/view.vue' //团队成员管理 查看成員信息
import PersonalTeammemberAdd from '@/components/Personal/teammember/add.vue' //团队成员管理 新增参会人
import PersonalTeammemberWyxf from '@/components/Personal/teammember/wyxf.vue' //团队成员管理 我要学分
import PersonalTeammemberXf from '@/components/Personal/teammember/xf.vue' //团队成员管理 成员学分
import PersonalTeammemberEdit from '@/components/Personal/teammember/edit.vue' //团队成员管理 查看编辑参会人信息
import PersonalPaymentmanagement from '@/components/Personal/paymentmanagement.vue' //交费管理
import PersonalOrdermanagement from '@/components/Personal/ordermanagement.vue' //订单管理
import PersonalInvoicesmanagement from '@/components/Personal/invoicesmanagement.vue' //发票管理
import PersonalApplyTransfer from '@/components/Personal/applyTransfer.vue' //转赠
import Bmxx from '@/components/Personal/bmxx.vue' //个人 报名信息
import Sqfp from '@/components/Personal/sqfp.vue' //个人 申请发票
import Sqxf from '@/components/Personal/sqxf.vue' //个人 申请学分

Vue.use(Router)

export default new Router({
  mode:'history',
  base:'/BaoMing/Wapbm/dist',
  routes: [
    {
      path: '/Guide/index',
      name: 'Guide',
      component: Guide
    },
    {
      path: '/index',
      name: 'Home',
      component: Home
    },
	{
	  path: '/Wyxf/index',
	  name: 'Wyxf',
	  component: Wyxf
	},
    {
      path: '/Fpgl/index',
      name: 'Fpgl',
      component: Fpgl
    },
    {
      path: '/free/index',
      name: 'Free',
      component: Free
    },
    {
      path: '/charge/pay',
      name: 'ChargePay',
      component: ChargePay
    },
    {
      path: '/charge/pay/index',
      name: 'ChargePayIndex',
      component: ChargePayIndex
    },
    {
      path: '/charge/remittance',
      name: 'ChargeRemittance',
      component: ChargeRemittance
    },
    {
      path: '/charge/remittance/index',
      name: 'RemittanceIndex',
      component: RemittanceIndex
    },
    {
      path: '/examine/index',
      name: 'Examine',
      component: Examine
    },
    {
      path: '/getWxOpenId/index',
      name: 'getWxOpenId',
      component: getWxOpenId
    },
    {
      path: '/getWxOpenId/grzx',
      name: 'getWxOpenIdGrzx',
      component: getWxOpenIdGrzx
    },
    {
      path: '/personal/index',
      name: 'Personal',
      component: Personal
    },
	{
	  path: '/personal/testindex',
	  name: 'testindex',
	  component: testindex
	},
    {
      path: '/personal/login',
      name: 'PersonalLogin',
      component: PersonalLogin
    },
	{
	  path: '/personal/testlogin',
	  name: 'testlogin',
	  component: testlogin
	},
	{
	  path: '/personal/teamreg',
	  name: 'PersonalTeamreg',
	  component: PersonalTeamreg
	},
	{
	  path: '/personal/teammember',
	  name: 'PersonalTeammember',
	  component: PersonalTeammember
	},
	{
		path:'/personal/member/view',
		name: 'PersonalTeammemberView',
		component: PersonalTeammemberView
	},
	{
		path:'/personal/member/fp',
		name: 'PersonalTeammemberFp',
		component: PersonalTeammemberFp
	},
	{
		path:'/personal/member/add',
		name: 'PersonalTeammemberAdd',
		component: PersonalTeammemberAdd
	},
	{
		path:'/personal/member/wyxf',
		name: 'PersonalTeammemberWyxf',
		component: PersonalTeammemberWyxf
	},
	{
		path:'/personal/member/xf',
		name: 'PersonalTeammemberXf',
		component: PersonalTeammemberXf
	},
	{
		path:'/personal/member/edit',
		name: 'PersonalTeammemberEdit',
		component: PersonalTeammemberEdit
	},
	{
		path: '/personal/paymentmanagement',
		name: 'PersonalPaymentmanagement',
		component: PersonalPaymentmanagement
	},
	{
		path: '/personal/ordermanagement',
		name: 'PersonalOrdermanagement',
		component: PersonalOrdermanagement
	},
	{
		path: '/personal/invoicesmanagement',
		name: 'PersonalInvoicesmanagement',
		component: PersonalInvoicesmanagement
	},
	{
		path: '/personal/applyTransfer',
		name: 'PersonalApplyTransfer',
		component: PersonalApplyTransfer
		
	},
    {
      path: '/personal/bmxx',
      name: 'Bmxx',
      component: Bmxx
    },
    {
      path: '/personal/sqfp',
      name: 'Sqfp',
      component: Sqfp
    },
    {
      path: '/personal/sqxf',
      name: 'Sqxf',
      component: Sqxf
    },
    { path: '*', component: NotFoundComponent }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js